import { render } from "./AppLayout.vue?vue&type=template&id=2f75d5f1"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"

import "./AppLayout.vue?vue&type=style&index=0&id=2f75d5f1&lang=css"
script.render = render

export default script